import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const AboutProfessional: StyleRule = ({ theme }) => ({
    paddingBottom: pxToRem(18),
    [theme.screen.laptop]: {
        paddingBottom: 0,
    },
});
